// Custom 2-handle slider for numeric metafield filters of filter.type == 'list'.
// Builds a multi-value list-filter URL on commit (mouseup / change / touchend).
// See snippets/facets-numeric-slider.liquid.

class NumericSlider extends HTMLElement {
  constructor() {
    super();
    this.lower = this.querySelector('[data-numeric-thumb="lower"]');
    this.upper = this.querySelector('[data-numeric-thumb="upper"]');
    this.outLower = this.querySelector('[data-numeric-out="lower"]');
    this.outUpper = this.querySelector('[data-numeric-out="upper"]');
    this.min = parseFloat(this.dataset.min);
    this.max = parseFloat(this.dataset.max);
    this.allValues = (this.dataset.values || '').split(',').map(v => parseFloat(v)).filter(v => !Number.isNaN(v));
    this.baseUrl = this.dataset.baseUrl || '';
    this.sep = this.dataset.separator || '?';
    this.paramName = this.dataset.paramName;

    if (!this.lower || !this.upper) return;

    this.lower.addEventListener('input', this.onSliderInput.bind(this));
    this.upper.addEventListener('input', this.onSliderInput.bind(this));
    this.lower.addEventListener('change', this.commit.bind(this));
    this.upper.addEventListener('change', this.commit.bind(this));
  }

  onSliderInput(e) {
    let lo = parseFloat(this.lower.value);
    let hi = parseFloat(this.upper.value);
    if (lo > hi) {
      if (e.target === this.lower) {
        this.lower.value = hi;
        lo = hi;
      } else {
        this.upper.value = lo;
        hi = lo;
      }
    }
    if (this.outLower) this.outLower.textContent = String(lo);
    if (this.outUpper) this.outUpper.textContent = String(hi);
    this.updateUsedBar(lo, hi);
  }

  updateUsedBar(lo, hi) {
    const span = this.max - this.min;
    if (span <= 0) return;
    const startPct = ((lo - this.min) * 100) / span;
    const endPct = ((this.max - hi) * 100) / span;
    this.style.setProperty('--range-used-start-width', startPct + '%');
    this.style.setProperty('--range-used-end-width', endPct + '%');
  }

  commit() {
    const lo = parseFloat(this.lower.value);
    const hi = parseFloat(this.upper.value);
    // If full range selected, clear filter (navigate to base URL with no values).
    if (lo === this.min && hi === this.max) {
      window.location.href = this.baseUrl;
      return;
    }
    const matching = this.allValues.filter(v => v >= lo && v <= hi);
    if (matching.length === 0) {
      window.location.href = this.baseUrl;
      return;
    }
    const params = matching.map(v => `${this.paramName}=${encodeURIComponent(v)}`).join('&');
    window.location.href = `${this.baseUrl}${this.sep}${params}`;
  }
}

if (!customElements.get('numeric-slider')) {
  customElements.define('numeric-slider', NumericSlider);
}
